import React, { Component } from "react";

class MapAnalyticsMap extends Component {
  componentDidMount() {
    this.updateMap();
  }

  componentDidUpdate() {
    this.updateMap();
  }

  updateMap = () => {
    const map = new google.maps.Map(
      document.getElementById("map-analytics-map"),
      {
        zoom: 13
      }
    );

    const bounds = new google.maps.LatLngBounds();
    const markers = [];
    const infoWindows = [];

    this.props.checkins.forEach(checkin => {
      const checkinTime = new Date(checkin.time).toLocaleString();

      const infoWindow = new google.maps.InfoWindow({
        content: `<div>${checkin.deviceName}<br />${checkinTime}</div>`
      });

      infoWindows.push(infoWindow);

      bounds.extend({ lat: checkin.lat, lng: checkin.lng });

      const marker = new google.maps.Marker({
        position: { lat: checkin.lat, lng: checkin.lng },
        icon: {
          url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png"
        },
        map
      });

      let infoShowing = false;

      marker.addListener("click", function() {
        if (infoShowing) {
          infoWindow.close();
        } else {
          //close other info windows
          infoWindows.forEach(infoWindow => infoWindow.close());

          infoWindow.open(map, marker);
          map.panTo(marker.getPosition());
        }
        infoShowing = !infoShowing;
      });

      markers.push(marker);
    });

    if (markers.length) {
      map.fitBounds(bounds);
    } else {
      map.setCenter({ lat: -37.817986, lng: 144.979638 });
    }

    if (this.props.fences && this.props.showFences) {
      this.props.fences.forEach((fence, i) => {
        if (fence.type === "MultiLineString") {
          const path = fence.coordinates[0]
            .map(coordinate => {
              coordinate[0] = coordinate[0].replace(/\[/g, "");
              return {
                lng: Number(coordinate[0]),
                lat: Number(coordinate[1])
              };
            })
            .filter(({ lat, lng }) => !isNaN(lat) && !isNaN(lng));
          const line = new google.maps.Polyline({
            path,
            geodesic: true,
            strokeColor: "#2B4F81",
            fillOpacity: 0.45,
            strokeWeight: 2
          });
          line.setMap(map);
        } else {
          //TODO: support other types of fences
        }
      });
    }
  };

  render() {
    return <div id="map-analytics-map" />;
  }
}

export default MapAnalyticsMap;
